import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Card, Alert, Row, Col, Container } from 'react-bootstrap';
import authService from '../../shared/utils/authService';
import { EyeFill, EyeSlashFill, BarChartLineFill, PeopleFill, ShieldLockFill, PaletteFill, WalletFill } from 'react-bootstrap-icons';
import './Auth.css'; // Import the new auth-specific CSS

const Login = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        if (!email || !password) {
            setError('Please enter both email and password.');
            return;
        }

        try {
            await authService.login(email, password);
            onLogin();
            navigate('/');
        } catch (err) {
            console.error('Login error details:', err);
            if (err.response && err.response.data && err.response.data.detail) {
                setError(err.response.data.detail);
            } else {
                setError('Failed to login. Please check your credentials.');
            }
        }
    };

    return (
        <Container fluid className="auth-page-bg">
            <Row className="w-100 min-vh-100 align-items-center justify-content-center">
                {/* Left Column: Marketing/Informative Section */}
                <Col lg={6} md={6} className="d-none d-md-flex auth-marketing-section">
                    <h1 className="display-4 mb-4">Unlock Your Financial Potential.</h1>
                    <p className="lead mb-5">
                        Take control of your money with our intuitive finance manager. Track expenses,
                        manage assets, and gain powerful insights to achieve your financial goals.
                    </p>
                    <div className="marketing-mini-card-container">
                        <div className="marketing-mini-card">
                            <BarChartLineFill className="card-icon" />
                            <h5>Comprehensive Overview</h5>
                            <p>See all your finances in one intelligent, easy-to-understand dashboard.</p>
                        </div>
                        <div className="marketing-mini-card">
                            <WalletFill className="card-icon" />
                            <h5>Smart Budgeting</h5>
                            <p>Create and manage budgets effortlessly to stay on top of your spending.</p>
                        </div>
                        <div className="marketing-mini-card">
                            <ShieldLockFill className="card-icon" />
                            <h5>Secure & Private</h5>
                            <p>Your financial data is protected with bank-grade security and privacy.</p>
                        </div>
                    </div>
                </Col>

                {/* Right Column: Login Form */}
                <Col lg={4} md={8} sm={10} xs={12} className="auth-form-section">
                    <Card className="shadow-lg p-4 auth-card">
                        <Card.Body>
                            <div className="text-center mb-4">
                                <h1 className="text-primary mb-0">Expense Tracker</h1>
                                <p className="text-muted">Your Financial Hub</p>
                            </div>
                            <h2 className="text-center mb-4">Welcome Back!</h2>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleLogin}>
                                <Form.Group className="form-floating mb-3" controlId="floatingEmail">
                                    <Form.Control
                                        type="email"
                                        placeholder="name@example.com"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <Form.Label>Email address</Form.Label>
                                </Form.Group>
                                <Form.Group className="form-floating mb-3 password-input-group" controlId="floatingPassword">
                                    <Form.Control
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Password"
                                        required
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <Form.Label>Password</Form.Label>
                                    <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <EyeSlashFill /> : <EyeFill />}
                                    </span>
                                </Form.Group>
                                <Row className="d-flex justify-content-between align-items-center mb-3">
                                    <Col>
                                        <Form.Check type="checkbox" label="Remember me" />
                                    </Col>
                                    <Col className="text-end">
                                        <Link to="/forgot-password">Forgot Password?</Link>
                                    </Col>
                                </Row>
                                <Button className="w-100 mt-3 btn-primary" type="submit">
                                    Log In
                                </Button>
                            </Form>
                        </Card.Body>
                        <Card.Footer className="text-center auth-card-footer">
                            Need an account? <Link to="/signup">Sign Up</Link>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
